import * as React from "react";

import PageWrapper from "~/common/layout/PageWrapper";
import PageContent from "~/common/layout/PageContent";

import SideMenu from "../containers/common/SideMenu";
import ProductsHeaderTabs from "../containers/products/ProductsHeaderTabs";
import ProductGroupsHeader from "../containers/products/ProductGroupsHeader";
import PageContentWrapper from "~/common/layout/PageContentWrapper";
import ProductGroupList from "../containers/products/ProductGroupList";

export default function (children: JSX.Element | null = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <ProductGroupsHeader />
          <ProductsHeaderTabs />
          <PageContentWrapper>
            <ProductGroupList />
          </PageContentWrapper>
          {children}
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
}
